import React, { useState } from 'react';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import { CssBaseline, InputBase, Typography } from '@material-ui/core';
import InputCard from '../Input';

import Card from '../Card';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import Title from './Title/Title';

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: '300px',
    backgroundColor: '#EBECF0',
    marginLeft: theme.spacing(2),
  },

  cardContainer: {
    padding: theme.spacing(1),
  },
}));

export default function Column({ list, handleUpdateTitle, index }) {
  const classes = useStyles();
  return (
    <Draggable draggableId={list.id} index={index}>
      {(provided) => (
        <div {...provided.draggableProps} ref={provided.innerRef}>
          <Paper className={classes.root} {...provided.dragHandleProps}>
            <CssBaseline />
            <Title
              originTitle={list.title}
              handleUpdateTitle={handleUpdateTitle}
              titleListId={list.id}
            />
            <Droppable droppableId={list.id} type="task">
              {(provided, snapshot) => (
                <div
                  className={classes.cardContainer}
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                >
                  {list.cards.map((card, index) => {
                    return <Card card={card} key={card.id} index={index} />;
                  })}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>

            <InputCard type="card" listId={list.id} />
          </Paper>
        </div>
      )}
    </Draggable>
  );
}
